<template>

    <div class="w-full h-full flex justify-center items-center">
        <div class="bg-white shadow rounded-lg text-4xl p-4">
            <font-awesome-icon fixed-width icon="spinner" pulse class="mr-2 font-4xl"></font-awesome-icon>
            {{message}}
        </div>
    </div>

</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faSpinner} from '@fortawesome/free-solid-svg-icons'

import User from '../classes/User'

export default {
    data() {
        return {
            User: new User(),
            message: 'Finding User...'
        }
    },

    created() {
        library.add(faSpinner)
    },

    mounted() {
        localStorage.setItem('access_code', this.$route.query.ac);

        this.getUserByGuid();
    },

    methods: {
        getUserByGuid() {
            const guid = this.$route.query.guid || null;

            if (!guid) {
                this.$router.push({
                    name: 'login',
                    query: {...this.$route.query}
                });
                return;
            }

            this.User.userGuid({guid})
                .then(response => {
                    if (!response.success) {
                        this.$router.push({name: 'login', query: {e: '1'}});
                        return;
                    }
                    this.message = "Logging in...";
                    this.login(response.data.username, response.data.password);
                })
                .catch(error => {
                    console.error("Error finding user by GUID: ", error);
                    this.$router.push({
                        name: 'login',
                        query: {...this.$route.query, e: '1'}
                    });
                });
        },

        login(username, password) {
            this.$auth.login({
                data: {
                    username,
                    password,
                    guid: true,
                },
                success: (response) => {
                    this.$auth.user(response.data.data);
                    this.message = "Redirecting...";

                    feedback('Successfully Logged In', 'success');
                    this.$router.push({name: 'order', query: {auto: 1}});
                },
                error: (error) => {
                    this.message = "Redirecting...";

                    feedback('Error signing in: ' + error.response.data.message, 'danger');
                    console.error("Error signing in: ", error.response.data.message);

                    this.$router.push({
                        name: 'login',
                        query: {...this.$route.query}
                    });
                },
                rememberMe: false,
                fetchUser: false
            });
        }
    }
}
</script>
